import { SquareFilterEnum } from '../../components/Views/ResidencesPage/types';
import { ResidenceSort } from '../../graphql/graphql';

const TO_ALL_MAP: Partial<Record<ResidenceSort, ResidenceSort>> = {
  [ResidenceSort.PricePerSqmAsc]: ResidenceSort.PriceAsc,
  [ResidenceSort.PricePerSqmDesc]: ResidenceSort.PriceDesc
};

const TO_PER_SQR_MAP: Partial<Record<ResidenceSort, ResidenceSort>> = {
  [ResidenceSort.PriceAsc]: ResidenceSort.PricePerSqmAsc,
  [ResidenceSort.PriceDesc]: ResidenceSort.PricePerSqmDesc
};

export const normalizeResidencesSortForUrl = (
  squareFilterValue: SquareFilterEnum,
  sortingValue: ResidenceSort
): ResidenceSort | string => {
  let sortValue = '';

  if (squareFilterValue === SquareFilterEnum.all) {
    sortValue = TO_ALL_MAP[sortingValue] ?? '';
  } else if (squareFilterValue === SquareFilterEnum.perSqr) {
    sortValue = TO_PER_SQR_MAP[sortingValue] ?? '';
  }

  return sortValue;
};
